import { Box, Icon, Text } from '@nimbus-ds/components';
import { ForbiddenIcon } from '@nimbus-ds/icons';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

export function DomainNotAvailableCard() {
  const t = useTranslationConfigurations(
    'domains.landing.addDomainModal.searchNewDomain',
  );

  return (
    <Box
      borderColor="danger-surfaceHighlight"
      borderStyle="solid"
      borderWidth="1"
      borderRadius="2"
      padding="4"
      display="flex"
      flexDirection="column"
      gap="2"
      boxShadow="2"
    >
      <Box display="flex" alignItems="center" gap="1">
        <Icon source={<ForbiddenIcon size="small" />} color="danger-textLow" />
        <Text fontSize="base" color="danger-textLow">
          {t('domainNotAvailableTitle')}
        </Text>
      </Box>
      <Text fontSize="caption" color="neutral-textLow">
        {t('domainNotAvailableDescription')}
      </Text>
    </Box>
  );
}
